// Button: Luxury pill shape, magnetic hover, smooth arrow translate
export default function Button({ children, variant = "primary", href, external = false, className: extraClass = "", ...props }) {
  const base = "group inline-flex items-center justify-center gap-2 px-8 py-3 rounded-full font-sans font-medium text-xs tracking-[0.1em] transition-all duration-500 uppercase";
  const variants = {
    primary: "bg-accent text-primary border border-accent hover:bg-primary hover:text-warm-white hover:border-primary hover:scale-[1.02] hover:shadow-[0_8px_30px_rgba(194,166,97,0.25)]",
    secondary: "bg-transparent text-primary border border-primary/30 hover:bg-accent/5 hover:border-accent-dark hover:text-accent-dark hover:scale-[1.02]",
    light: "bg-transparent text-[#FAF8F4] border border-[#FAF8F4]/50 hover:bg-[#C2A661] hover:text-[#232323] hover:border-[#C2A661] hover:scale-[1.02]"
  };

  const className = `${base} ${variants[variant]} ${extraClass}`.trim();
  const arrowHtml = (
    <span className="inline-block transition-transform duration-500 ease-out font-serif text-lg leading-none -mt-0.5 group-hover:translate-x-1">→</span>
  );
  
  if (href) {
    const externalProps = external ? { target: "_blank", rel: "noopener noreferrer" } : {};
    return (
      <a href={href} className={className} {...externalProps} {...props}>
        {children} {arrowHtml}
      </a>
    );
  }
  
  return (
    <button className={className} {...props}>
      {children} {arrowHtml}
    </button>
  );
}